import { styled, Button as MuiButton } from "@mui/material";
import { jordyBlue, black } from "shared/assets/colors";

const PREFIX = "UserGroupFormStyles";
export const classes = {
  deleteButton: `${PREFIX}-deleteButton`,
  cancelButton: `${PREFIX}-cancelButton`,
  fillButton: `${PREFIX}-fillButton`,
};

export const Button = styled(MuiButton)(() => ({
  [`&.${classes.deleteButton}`]: {
    color: jordyBlue,
    marginRight: "auto",
  },
  [`&.${classes.cancelButton}`]: {
    color: black,
  },
  [`&.${classes.fillButton}`]: {
    padding: 0,
    color: black,
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    textTransform: "none",
    fontSize: "1rem",
  },
}));
